fragment Campaign on Campaign {
    _id
    id
    name
    campaignType
    hasContent
    jiraTicketUrl
    wppProjectId
    opendcPlatformSettings {
        campaignType
    }
    creativeXPlatformSettings {
        marketCode
        channel
        publisher
        placement
        campaignObjective
        contentType
        adFormat
        assetType
    }
    mastheadImageUrl
    isLocked
    toneOfVoice
    defaultTimelineLength
    section {
        _id
    }
    groupFeedMappings {
        group
        primaryKey
        feedUrl
    }
}
